import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`

export const Skeleton = styled.div`
  background: #ebebf2;
  background-image: linear-gradient(
    90deg,
    #ebebf2 0px,
    #f5f5fa 40px,
    #ebebf2 80px
  );
  background-size: 600px;
  animation: ${shimmer} 1.6s infinite linear forwards;
  border-radius: ${(props) => props.radius || '8px'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '20px'};
`

export const SkeletonDark = styled.div`
  background: rgba(255, 255, 255, 0.15);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.15) 0px,
    rgba(255, 255, 255, 0.28) 40px,
    rgba(255, 255, 255, 0.15) 80px
  );
  background-size: 600px;
  animation: ${shimmer} 1.6s infinite linear forwards;
  border-radius: ${(props) => props.radius || '8px'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '20px'};
`

export const SkeletonCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 4px 15px rgba(25, 27, 53, 0.04);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
`

export const SkeletonRow = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 1rem 1.25rem;
  box-shadow: 0 4px 15px rgba(25, 27, 53, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

/* ===== Layout base ===== */
export const Page = styled.div`
  min-height: 100vh;
  background: #f7f7fb;
  padding: 1.5rem 1rem 4rem;

  @media (min-width: 768px) {
    padding: 2.5rem 1.25rem 4rem;
  }
`

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
`

export const Greeting = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: #7241a1;
  display: block;
  margin-bottom: 0.25rem;
`

/* ===== Botões do header ===== */
export const LogoutButton = styled.button`
  background: transparent;
  border: 1px solid #d2d5eb;
  color: #575b71;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #ffebee;
    border-color: #ffcdd2;
    color: #d32f2f;
  }
`

export const ProfileButton = styled.button`
  background: #f0fdf4;
  border: 1px solid #00C853;
  color: #2e7d32;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #00C853;
    color: #fff;
  }
`

/* ===== Linha de cards principais (Saldo + Código) ===== */
export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`

/* ===== Card de Saldo ===== */
export const BalanceCard = styled.div`
  background: linear-gradient(135deg, #7241a1, #512b7a);
  border-radius: 16px;
  padding: 1.5rem;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 10px 30px rgba(114, 65, 161, 0.2);

  @media (min-width: 640px) {
    padding: 2rem;
  }
`

export const BalanceLabel = styled.p`
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.85;
`

export const BalanceValue = styled.h2`
  margin: 0;
  font-size: 2.2rem;
  font-weight: 800;
  letter-spacing: -0.5px;
`

export const BalanceSubInfo = styled.p`
  margin: 0;
  font-size: 0.85rem;
  opacity: 0.85;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  align-self: flex-start;

  strong {
    font-weight: 800;
    margin-left: 0.25rem;
  }
`

export const WithdrawButton = styled.button`
  background: #fff;
  color: #7241a1;
  border: none;
  padding: 0.85rem 1.5rem;
  border-radius: 10px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  margin-top: 0.25rem;

  @media (min-width: 640px) {
    width: auto;
    align-self: flex-start;
  }

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`

/* ===== Card de Código de Indicação ===== */
export const CodeCard = styled.div`
  background: linear-gradient(135deg, #7241a1, #512b7a);
  border-radius: 16px;
  padding: 1.5rem;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  box-shadow: 0 10px 30px rgba(114, 65, 161, 0.2);

  @media (min-width: 640px) {
    padding: 2rem;
  }
`

export const CodeInfo = styled.div`
  p {
    margin: 0 0 0.5rem 0;
    font-size: 0.9rem;
    opacity: 0.85;
  }

  .codigo-box {
    display: flex;
    align-items: center;
    gap: 1rem;

    h2 {
      margin: 0;
      font-size: 2.2rem;
      letter-spacing: 2px;
    }

    .edit-btn {
      background: rgba(255, 255, 255, 0.2);
      border: none;
      color: #fff;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      font-size: 1.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background 0.2s;

      &:hover {
        background: rgba(255, 255, 255, 0.4);
      }
    }
  }
`

export const CopyButton = styled.button`
  background: #fff;
  color: #7241a1;
  border: none;
  padding: 0.85rem 1.5rem;
  border-radius: 10px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;

  @media (min-width: 640px) {
    width: auto;
    align-self: flex-start;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  &.copied {
    background: #00C853;
    color: #fff;
  }
`

/* ===== Banner de saque pendente ===== */
export const PendingBanner = styled.div`
  background: linear-gradient(135deg, #fff8e1 0%, #ffe7b3 100%);
  border: 1px solid #f5c878;
  border-left: 6px solid #ed6c02;
  border-radius: 16px;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .content {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    min-width: 0;
  }

  .icon {
    font-size: 1.6rem;
    flex-shrink: 0;
  }

  .text {
    display: flex;
    flex-direction: column;
    min-width: 0;

    strong {
      color: #1f2241;
      font-size: 1rem;
    }
    span {
      color: #6b6f83;
      font-size: 0.85rem;
      margin-top: 0.15rem;
    }
  }

  .btn-cancel-pending {
    background: transparent;
    color: #d32f2f;
    border: 1px solid #d32f2f;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s;

    &:hover:not(:disabled) {
      background: #d32f2f;
      color: #fff;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`

/* ===== Stats ===== */
export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 640px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const StatCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(25, 27, 53, 0.04);
  text-align: center;

  h3 {
    margin: 0;
    font-size: 2rem;
    color: #1f2241;
  }
  p {
    margin: 0.25rem 0 0 0;
    color: #6b6f83;
    font-size: 0.9rem;
    font-weight: 600;
  }
`

export const SectionTitle = styled.h3`
  margin: 1rem 0 0 0;
  color: #1f2241;
  font-size: 1.25rem;
`

export const EmptyState = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 3rem 1.5rem;
  text-align: center;
  color: #6b6f83;
  font-weight: 600;
  border: 2px dashed #d2d5eb;
`

/* ===== Indicações ===== */
export const IndicationsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const IndicationCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 4px 15px rgba(25, 27, 53, 0.04);
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const IndicationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;

  .info {
    display: flex;
    flex-direction: column;

    strong {
      color: #1f2241;
      font-size: 1.05rem;
    }
    span {
      color: #6b6f83;
      font-size: 0.8rem;
      margin-top: 0.2rem;
    }
  }
`

export const IndicationActions = styled.div`
  display: flex;
  justify-content: flex-end;

  .btn-details {
    background: transparent;
    color: #7241a1;
    border: 1px solid #7241a1;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #7241a1;
      color: #fff;
      transform: translateY(-1px);
      box-shadow: 0 4px 10px rgba(114, 65, 161, 0.2);
    }
  }
`

export const StatusBadge = styled.span`
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;

  &.pending {
    background: #fff4e5;
    color: #ed6c02;
  }
  &.success {
    background: #edf7ed;
    color: #2e7d32;
  }
`

export const ProgressBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  .labels {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    font-weight: 600;
    color: #4b4f68;
  }
`

export const ProgressBar = styled.div`
  height: 8px;
  background: #f0f0f5;
  border-radius: 999px;
  overflow: hidden;
`

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(120deg, #ff9134, #ff7b1c);
  border-radius: 999px;
  transition: width 0.5s ease-in-out;

  &.success {
    background: #00C853;
  }
`

/* ===== Histórico de transações ===== */
export const TransactionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const TransactionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background: #fff;
  border-radius: 16px;
  padding: 1rem 1.25rem;
  box-shadow: 0 4px 15px rgba(25, 27, 53, 0.04);
  border-left: 4px solid
  ${(p) => (p.className === 'credito' ? '#00C853' : '#d32f2f')};

  .left {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    min-width: 0;
  }

  .tipo-badge {
    font-size: 0.72rem;
    font-weight: 800;
    padding: 0.3rem 0.65rem;
    border-radius: 999px;
    white-space: nowrap;

    &.credito {
      background: #edf7ed;
      color: #2e7d32;
    }
    &.debito {
      background: #ffebee;
      color: #d32f2f;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    min-width: 0;

    strong {
      font-size: 0.95rem;
      color: #1f2241;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span {
      font-size: 0.78rem;
      color: #6b6f83;
      margin-top: 0.15rem;
    }
  }

  .valor {
    font-weight: 800;
    font-size: 1.05rem;
    white-space: nowrap;

    &.credito {
      color: #2e7d32;
    }
    &.debito {
      color: #d32f2f;
    }
  }
`

/* ===== Detalhes da indicação (modal) ===== */
export const DetailsHeader = styled.div`
  background: #f8f5fc;
  border: 1px solid #ece2f5;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  > div:first-child {
    display: flex;
    flex-direction: column;

    strong {
      color: #1f2241;
      font-size: 1.1rem;
    }
    span {
      color: #6b6f83;
      font-size: 0.85rem;
      margin-top: 0.2rem;
    }
  }
`

export const DetailsStats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;

  > div {
    background: #fff;
    border-radius: 10px;
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    span {
      font-size: 0.7rem;
      color: #6b6f83;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.4px;
    }
    strong {
      font-size: 1rem;
      color: #7241a1;
      font-weight: 800;
    }
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const DeliveryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;

  th,
  td {
    text-align: left;
    padding: 0.65rem 0.5rem;
    border-bottom: 1px solid #f0f0f5;
  }

  th {
    color: #7241a1;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.5px;
  }

  td {
    color: #1f2241;
    font-weight: 600;
  }

  tr:last-child td {
    border-bottom: none;
  }

  .status {
    font-size: 0.72rem;
    padding: 0.25rem 0.6rem;
    border-radius: 999px;
    font-weight: 700;
    white-space: nowrap;

    &.success {
      background: #edf7ed;
      color: #2e7d32;
    }
    &.pending {
      background: #fff4e5;
      color: #ed6c02;
    }
  }

  .comissao {
    color: #2e7d32;
    font-weight: 800;
  }

  .muted {
    color: #b8bccf;
  }
`

/* ===== Modal ===== */
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(31, 34, 65, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
`

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  animation: slideUp 0.3s ease-out;
  max-height: 90vh;
  overflow-y: auto;

  @keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  h3 {
    margin: 0;
    color: #1f2241;
    font-size: 1.4rem;
  }

  h4 {
    margin: 0;
    color: #1f2241;
    font-size: 1rem;
  }

  .desc {
    margin: 0;
    font-size: 0.9rem;
    color: #6b6f83;
    line-height: 1.4;

    span {
      display: block;
      margin-top: 0.25rem;
      font-weight: 600;
      color: #7241a1;
    }
  }

  input {
    width: 100%;
    padding: 1rem;
    font-size: 1.5rem;
    font-weight: 800;
    text-align: center;
    letter-spacing: 2px;
    color: #1f2241;
    border: 2px solid #d2d5eb;
    border-radius: 12px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: #7241a1;
    }
  }

  .error-msg {
    color: #d7263d;
    font-size: 0.85rem;
    font-weight: 600;
    text-align: center;
  }

  .actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-top: 0.5rem;

    button {
      padding: 0.85rem;
      border-radius: 10px;
      font-weight: 700;
      cursor: pointer;
      transition: opacity 0.2s;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .btn-cancel {
      background: #f6f7fb;
      color: #575b71;
      border: 1px solid #d2d5eb;
    }

    .btn-save {
      background: #00C853;
      color: #fff;
      border: none;
    }
  }

  &.large {
    max-width: 560px;
  }

  input.main-input-modal {
    text-align: center;
    font-size: 1.5rem;
    letter-spacing: 2px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-bottom: 0.5rem;

    label {
      font-size: 0.85rem;
      font-weight: 700;
      color: #1f2241;
    }

    input,
    select {
      width: 100%;
      padding: 0.85rem 1rem;
      border: 1px solid #d2d5eb;
      border-radius: 10px;
      font-size: 1rem;
      color: #1f2241;
      font-weight: 600;
      background: #f8f8ff;
      transition: border-color 0.2s;
      text-align: left;
      letter-spacing: normal;

      &:focus {
        border-color: #7241a1;
        outline: none;
        background: #fff;
      }
    }

    .warning-text {
      font-size: 0.75rem;
      color: #ed6c02;
      font-weight: 600;
      margin-top: 0.2rem;
    }
  }

  .form-grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .status-msg {
    font-size: 0.85rem;
    font-weight: 700;
    text-align: center;
    padding: 0.75rem;
    border-radius: 8px;

    &.error {
      background: #ffebee;
      color: #d32f2f;
    }

    &.success {
      background: #edf7ed;
      color: #2e7d32;
    }
  }
`
